import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Intent, InputGroup, TextArea } from '@blueprintjs/core';
import { Row, Col } from 'reactstrap';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import styled from 'styled-components';
import moment from 'moment';

import SelectBoPhanBanHanh from 'components/elements/select-bo-phan-ban-hanh';
import SelectLoaiVanBan from 'components/elements/select-loai-van-ban';
import SelectLinhVuc from 'components/elements/select-linh-vuc';
import SelectTinhTrangVanBan from 'components/elements/select-tinh-trang-van-ban';
import DateInput from 'components/elements/date-input';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
import { DATE_FORMAT } from 'config';

import IconRequired from 'components/elements/required-icon';
import Clearfix from 'components/elements/clearfix';
// import dynamicRoleHOC from 'hoc/dynamicRole';
import { COLOR } from 'config';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

// @dynamicRoleHOC()
class AuditForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    onSubmit: PropTypes.func,
  };

  setInitialValue(keyPath, defaultValue, type = '') {
    let value = _.result(this.props.initialValue, keyPath, defaultValue);
    if (value) {
      switch (type) {
        case 'select':
          return {
            value: value._id,
            label: value.Name ? value.Name : value.FacilityNameFull,
          };
        case 'date':
          return moment(value).format();
        case 'dates':
          return `${moment(value[0]).format()} - ${moment(value[1]).format()}`;
        default:
          return value;
      }
    }

    return value;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (error) return;
      if (value.promulgate) {
        value.promulgate = _.get(value, 'promulgate.value', null);
      }
      if (value.type) {
        value.type = _.get(value, 'type.value', null);
      }
      if (value.mainField) {
        value.mainField = _.get(value, 'mainField.value', null);
      }
      if (value.status) {
        value.status = _.get(value, 'status.value', null);
      }
      if (this.props.onSubmit) this.props.onSubmit(value);
    });
  };

  onSuccessUpload = (res) => {
    if (res) {
      this.props.form.setFieldsValue({
        complianceFile: res,
      });
    }
  };

  render() {
    const {
      getFieldProps,
      getFieldError,
      getFieldValue,
      validateFields,
    } = this.props.form;

    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Quản lý văn bản pháp lý
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Số văn bản
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Số văn bản'
              {...getFieldProps('LegalDocumentNumber', {
                initialValue: this.setInitialValue('LegalDocumentNumber', ''),
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: 'Vui lòng nhập số văn bản',
                  },
                  {
                    whitespace: true,
                    min: 3,
                    max: 64,
                    message: 'Số văn bản có độ dài từ 3 -> 64 kí tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('LegalDocumentNumber') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Bộ phận ban hành</LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectBoPhanBanHanh
              fieldForm={{
                form: this.props.form,
                name: 'promulgate',
                option: {
                  initialValue: this.setInitialValue(
                    'promulgate',
                    null,
                    'select'
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Loại văn bản</LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectLoaiVanBan
              fieldForm={{
                form: this.props.form,
                name: 'type',
                option: {
                  initialValue: this.setInitialValue('type', null, 'select'),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Nội dung văn bản</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Nội dung văn bản'
              {...getFieldProps('Content', {
                initialValue: this.setInitialValue('Content', ''),
                rules: [
                  {
                    min: 0,
                    max: 1000,
                    message: 'Nội dung văn bản có độ dài lớn hơn 1000 kí tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Content') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Lĩnh vực</LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectLinhVuc
              fieldForm={{
                form: this.props.form,
                name: 'mainField',
                option: {
                  initialValue: this.setInitialValue(
                    'mainField',
                    null,
                    'select'
                  ),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Người ký</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Người ký'
              {...getFieldProps('Signer', {
                initialValue: this.setInitialValue('Signer', ''),
                rules: [
                  {
                    min: 0,
                    max: 64,
                    message: 'Nội dung văn bản có độ dài lớn hơn 64 kí tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Signer') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày ban hành</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày ban hành'
              {...getFieldProps('IssueDate', {
                initialValue: convertDate(
                  this.setInitialValue('IssueDate', '', 'date')
                ),
                rules: [
                  (rule, value, callback) => {
                    let ExpiryDate = getFieldValue('ExpiryDate');
                    let IssueDate = value;

                    let isError = false;

                    if (ExpiryDate) {
                      if (ExpiryDate < IssueDate) isError = true;
                    }
                    if (isError) {
                      callback(
                        new Error('Ngày ban hành phải nhỏ hơn ngày hết hạn')
                      );
                    } else {
                      if (
                        getFieldError('ExpiryDate') &&
                        getFieldError('ExpiryDate').length > 0
                      ) {
                        validateFields(['ExpiryDate'], {
                          force: true,
                        });
                      }
                      // this.props.form.validateFields(["ExpiryDate"], { force: true });
                      callback();
                    }
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('IssueDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày hết hạn</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày hết hạn'
              {...getFieldProps('ExpiryDate', {
                initialValue: convertDate(
                  this.setInitialValue('ExpiryDate', '', 'date')
                ),
                rules: [
                  (rule, value, callback) => {
                    let IssueDate = getFieldValue('IssueDate');
                    let ExpiryDate = value;
                    let isError = false;

                    if (ExpiryDate) {
                      if (ExpiryDate < IssueDate) isError = true;
                    }

                    if (!isError) {
                      if (
                        getFieldError('IssueDate') &&
                        getFieldError('IssueDate').length > 0
                      ) {
                        validateFields(['IssueDate'], {
                          force: true,
                        });
                      }

                      callback();
                    } else
                      callback(
                        new Error('Ngày hết hạn phải lớn hơn ngày ban hành')
                      );
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('ExpiryDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Tình trạng</LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectTinhTrangVanBan
              fieldForm={{
                form: this.props.form,
                name: 'status',
                option: {
                  initialValue: this.setInitialValue('status', null, 'select'),
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('Note', {
                initialValue: this.setInitialValue('Note', ''),
              })}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default createForm()(AuditForm);



// WEBPACK FOOTER //
// ./src/containers/LegalDocument/LegalDocumentForm/index.js